import { Component } from '@angular/core';
import { App, LoadingController, NavController } from 'ionic-angular';
import { ITeam, LineUpService, TshirtStyle } from '../../../../../lineup/services/lineup-service';
import { TournamentService, IPlan, PlanEnum } from '../../../../services/tournament.service';
import { SportAlgoUtils } from '../../../../services/sport.algo';

@Component({
  selector: 'twog-ko-pl',
  templateUrl: 'twog-ko-pl.html',
})
export class TwoGKoPlPage {
  plan = {
    id: 0,
    plantype: PlanEnum.GruKoPlPage,
    sportArt: "Fußball",
    name: "",
    rounds: 1,
    days: 7,
    games: 18,
    teamNum: 8,
    groupNum: 2,
    groupSize: 4,
    roundPhase: false,
    teams: [],
    gameTable: [],
    roundTeams: [],
    roundGameTable: []
  };

  /**
   *  @TODO
   *  sportArt -> sporttype, getSportName(), ui change 12 sport modes. 
   *  to be applied for the rest 3 modes. 
   * */

  constructor(
    private gs: TournamentService,
    private app: App,
    private ls: LineUpService,
    private navCtrl: NavController,
    private loader: LoadingController
  ) { }

  ionViewDidLoad() {
    this.plan.name = "Spielplan " + this.gs.planList.length;
  }

  save() {
    this.createTeams();
    this.setMatches();
    this.gs.planList.push(this.plan);
    this.gs.save();
    let load = this.loader.create({});
    load.present();
    this.app.getRootNav().getActiveChildNav().select(0);
    this.navCtrl.popToRoot().then(() => {
      console.log('done');
      load.dismiss();
      this.app.getRootNav().getActiveChildNav().select(1);
    });
  }

  filter(plan: any) {
    let obj = JSON.parse(JSON.stringify(plan));
    delete obj.gameTable;
    delete obj.roundTeams;
    delete obj.roundGameTable;
    delete obj.id;
    return obj;
  }

  navigate() {
    let load = this.loader.create({});
    load.present();
    this.app.getRootNav().getActiveChildNav().select(0);
    this.navCtrl.popToRoot().then(() => {
      console.log('done');
      load.dismiss();
      this.app.getRootNav().getActiveChildNav().select(1);
    });
  }
  onGroupSizeChange() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
    this.plan.teamNum = Math.floor((this.plan.groupNum)) * Math.floor(this.plan.groupSize);
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onGroupNumChange() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
    this.plan.teamNum = this.plan.groupNum * this.plan.groupSize;
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onTeamNumChange() {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
    this.plan.groupNum = this.plan.teamNum / this.plan.groupSize;
    this.plan.days = this.plan.games = Math.floor((this.plan.teamNum) - 1);
  }

  onGroupSizeChangeMan() {
    this.plan.groupSize = Math.floor(this.plan.groupSize);
  }

  onGroupNumChangeMan() {
    this.plan.groupNum = Math.floor(this.plan.groupNum);
  }

  onTeamNumChangeMan() {
    this.plan.teamNum = Math.floor(this.plan.teamNum);
  }

  createTeams() {
    let gN = Number(this.plan.groupNum);
    let gS = Number(this.plan.groupSize);

    let ASCII = 65;
    let id = 0;
    for (let i = 0; i < gN; i++) {
      let group = [];
      for (let j = 0; j < gS; j++) {
        let team: ITeam = {
          id: id,
          name: 'Team ' + String.fromCharCode(ASCII) + (j + 1),
          results: 0,
          points: 0,
          ord:id + 1,
          players: []
        };
        this.plan.teams.push(team);
        group.push(team);
        id += 1;
      }
      this.plan.roundTeams.push(group);
      ASCII += 1;
    }
  }

  setMatches() {
    let gN = Number(this.plan.groupNum);
    let gS = Number(this.plan.groupSize);
    for (let r = 0; r < this.plan.rounds; r++) {
      let roundTable = [];
      for (let i = 0; i < gN; i++) {
        let table = SportAlgoUtils.createGamePlan(this.plan.teams.slice(i * gS, i * gS + gS), gS, this.plan, r);
        roundTable.push(table);
      }
      this.plan.gameTable.push(roundTable);
    }
  }


}







// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/new-tou/new-plan/twog-ko-pl/twog-ko-pl.ts